import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Container, Panel, Stack, Text } from 'shell/components';

const Desktop = ({ options, selected, onBeforeChange, onChange }) => {
    const { t } = useTranslation();

    return (
        <CustomContainer device={'desktop'}>
            <Stack spacing={2}>
                <Text component={'h1'} variant={'h6'} weight={'medium'}>
                    {t('course-settings.title', 'Course Settings')}
                </Text>
                <CustomPanel
                    options={options}
                    selected={selected}
                    onBeforeChange={onBeforeChange}
                    onChange={onChange}
                />
            </Stack>
        </CustomContainer>
    );
};

const CustomContainer = styled(Container)(() => {
    return {
        display: 'block',
        height: 'unset',
    };
});

const CustomPanel = styled(Panel)(() => {
    return {
        minHeight: '100%',
        height: 'auto',
    };
});

export default Desktop;
